const popover = {
  baseStyle: {
    // Mesmo motivo do modal: o padrão escuro do Chakra é gray.700 (azulado). A seta herda
    // --popper-bg, então trocar a variável mantém seta e caixa iguais.
    content: {
      _dark: { "--popper-bg": "colors.app-card", borderColor: "app-border" },
    },
  },
};

export default popover;
